import { requestApi } from '../util/network'

// 获取订单列表
export const getFuwuOrderList =
    (parmas, state) =>
      requestApi(
        '/o2o_fuwu_manage_order/get_list',
        'POST',
        {
          'page': parmas.page,
          'per_page': parmas.per_page,
          'o2o_fuwu_order_state': state
        },
        'fuwu'
      )
// 获取订单信息
export const getFuwuOrderInfo =
    (orderId) =>
      requestApi(
        '/o2o_fuwu_manage_order/get_info',
        'POST',
        {
            'o2o_fuwu_order_id': orderId
        },
        'fuwu'
      )

// 取消订单
export const cancelFuwuOrder =
    (orderId, reason) =>
      requestApi(
        '/o2o_fuwu_manage_order/cancel',
        'POST',
        {
            'o2o_fuwu_order_id': orderId,
          'reason': reason
        },
        'fuwu'
      )
// 安排订单
export const arrangeFuwuOrder =
    (orderId) =>
      requestApi(
        '/o2o_fuwu_manage_order/arrange',
        'POST',
        {
            'o2o_fuwu_order_id': orderId
        },
        'fuwu'
      )
